import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { REACT_APP_NAV_ROUTES } from "../../router/AppNavigation";

const DeliveryLogDetails = Loadable(
  lazy(() =>
    import("./DeliveryLogDetails").then(({ DeliveryLogDetails }) => ({
      default: DeliveryLogDetails,
    }))
  )
);

export const deliveryLogDetailsRoutes = [
  {
    path: REACT_APP_NAV_ROUTES.reports.deliveryLogDetails,
    
    element: <DeliveryLogDetails />,
  },
];
